import { Bell, HandMetal, PartyPopper, Search } from "lucide-react"

import { ActionDefinition } from "@/components/automations/types"

export const systemActions: ActionDefinition[] = [
  {
    key: "action__internal_notification",
    name: "Internal notification",
    description: "Send an internal notification to users",
    category: "system",
    nodeType: "action",
    icon: Bell,
    fields: [
      {
        key: "message_type",
        label: "Message type",
        inputType: "select",
        required: true,
        defaultValue: "email",
        options: [
          { value: "email", label: "Email" },
          { value: "sms", label: "SMS" },
        ],
      },
      {
        key: "to",
        label: "To",
        inputType: "multi_text",
        required: false,
        placeholder: "Enter email addresses",
        visibleWhen: { field: "message_type", values: ["email"] },
      },
      {
        key: "cc",
        label: "CC",
        inputType: "multi_text",
        required: false,
        placeholder: "Enter email addresses",
        visibleWhen: { field: "message_type", values: ["email"] },
      },
      {
        key: "bcc",
        label: "BCC",
        inputType: "multi_text",
        required: false,
        placeholder: "Enter email addresses",
        visibleWhen: { field: "message_type", values: ["email"] },
      },
      {
        key: "email_content",
        label: "Email content",
        inputType: "email_content",
        required: false,
        defaultValue: {
          subject: "",
          body: { html: "" },
        },
        visibleWhen: { field: "message_type", values: ["email"] },
        chatValueShape: '{"subject":"...","body":{"html":"..."}}',
        supportsInterpolation: true,
        interpolationHelperText: "Subject and body support variables from subject data and prior step results.",
      },
      {
        key: "sms_to",
        label: "To",
        inputType: "multi_text",
        required: false,
        placeholder: "Enter phone numbers",
        visibleWhen: { field: "message_type", values: ["sms"] },
      },
      {
        key: "sms_body",
        label: "Message",
        inputType: "textarea",
        required: false,
        visibleWhen: { field: "message_type", values: ["sms"] },
        supportsInterpolation: true,
      },
    ],
  },
  {
    key: "action__search_records",
    name: "Search records",
    description: "Search for records matching criteria",
    category: "system",
    nodeType: "action",
    icon: Search,
    featureFlagged: true,
    fields: [
      {
        key: "record_type",
        label: "Record type",
        inputType: "select",
        required: true,
        options: [
          { value: "household", label: "Household" },
          { value: "task", label: "Task" },
          { value: "opportunity", label: "Opportunity" },
          { value: "meeting", label: "Meeting" },
        ],
      },
      {
        key: "search_query",
        label: "Search query",
        inputType: "string",
        required: true,
        helperText: "Search criteria",
      },
    ],
  },
  {
    key: "action__user_action",
    name: "User action",
    description: "Prompt user to take a specific action",
    category: "system",
    nodeType: "action",
    icon: HandMetal,
    featureFlagged: true,
    fields: [
      {
        key: "user_ids",
        label: "Users",
        inputType: "string",
        required: true,
        helperText: "User IDs (comma-separated)",
      },
      {
        key: "action_prompt",
        label: "Action prompt",
        inputType: "textarea",
        required: true,
        helperText: "What action should the user take?",
      },
    ],
  },
  {
    key: "action__confetti",
    name: "Confetti",
    description: "Show a confetti celebration to users",
    category: "system",
    nodeType: "action",
    icon: PartyPopper,
    fields: [
      {
        key: "user_ids",
        label: "Users to celebrate",
        inputType: "multi_user_picker",
        required: true,
        optionsSource: "users",
      },
      {
        key: "style",
        label: "Animation style",
        inputType: "select",
        required: true,
        defaultValue: "fireworks",
        options: [
          { value: "fireworks", label: "Fireworks" },
          { value: "raining", label: "Raining" },
          { value: "cannons", label: "Cannons" },
        ],
      },
      {
        key: "celebration_message",
        label: "Celebration message",
        inputType: "text",
        required: false,
        placeholder: "Congratulations!",
      },
    ],
  },
]
